import { render } from "./PimLabProductsOverviewCriteria.vue?vue&type=template&id=b5a1d6c8&scoped=true&ts=true"
import script from "./PimLabProductsOverviewCriteria.vue?vue&type=script&lang=ts"
export * from "./PimLabProductsOverviewCriteria.vue?vue&type=script&lang=ts"

import "./PimLabProductsOverviewCriteria.vue?vue&type=style&index=0&id=b5a1d6c8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a1d6c8"]])

export default __exports__